/**
 * @file
 * Tab script.
 */

(function tabScript($, Drupal) {
  'use strict';

  Drupal.behaviors.tab = {
    attach: function tabAttach(context) {
      var $tabItems = $('.tab__item', context);
      // Handle setting the currently active link
      $tabItems
        .on('click', function (e) {
          e.preventDefault();
        })
        .hammer()
        .on('tap press', function () {
          $tabItems.attr('aria-selected', 'false');
          $(this).attr('aria-selected', 'true');
        });
    }
  };
}(jQuery, Drupal));
